import { CloseRounded, GitHub, LinkedIn } from '@mui/icons-material';
import { Modal } from '@mui/material';
import React from 'react'
import styled from 'styled-components'
import { RoughBox, RoughCircle } from '../common/Rough'

const Container = styled.div`
width: 100%;
height: 100%;
position: absolute;
top: 0;
left: 0;
background-color: #000000a7;
display: flex;
align-items: top;
justify-content: center;
overflow-y: scroll;
transition: all 0.5s ease;
`;

const Wrapper = styled.div`
max-width: 800px;
width: 100%;
margin: 50px 12px;
height: min-content;
position: relative;
color: ${({ theme }) => theme.text_primary};
`;

const Title = styled.div`
  font-family: 'Caveat', cursive;
  font-size: 38px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin: 8px 6px 0px 6px;
  @media only screen and (max-width: 600px) {
      font-size: 30px;
      margin: 6px 6px 0px 6px;
  }
`;

const Date = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 16px;
    margin: 2px 6px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`



const Desc = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    margin: 8px 6px;
    @media only screen and (max-width: 600px) {
        font-size: 14px;
        margin: 6px 6px;
    }
`;

const Image = styled.img`
    width: 100%;
    object-fit: cover;
    margin-top: 24px;
    filter: grayscale(0.1) contrast(1.05);
`;

const Label = styled.div`
    font-family: 'Caveat', cursive;
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.text_primary};
    margin: 8px 6px;
    @media only screen and (max-width: 600px) {
        font-size: 20px;
        margin: 8px 6px;
    }
`;

const Tags = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 8px 0px;
    @media only screen and (max-width: 600px) {
        margin: 4px 0px;
    }
`;

const Tag = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.primary};
    margin: 4px;
    padding: 4px 4px;
    @media only screen and (max-width: 600px) {
        font-size: 12px;
    }
`;

const Members = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-wrap: wrap;
    margin: 12px 6px;
    @media only screen and (max-width: 600px) {
        margin: 4px 6px;
    }
`;

const Member = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const MemberImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
`;

const MemberName = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 16px;
    font-weight: 500;
    width: 200px;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 600px) {
        font-size: 14px;
    }
`;


const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 12px 0px;
    gap: 12px;
`;

const Button = styled.a`
    display: block;
    width: 100%;
    text-align: center;
    font-family: 'Kalam', cursive;
    font-size: 16px;
    font-weight: 700;
    color: ${({ dull, theme }) => (dull ? theme.text_secondary : theme.primary)};
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
    &:hover {
        transform: rotate(-1deg) scale(1.03);
    }
    @media only screen and (max-width: 600px) {
        font-size: 13px;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: -14px;
    right: -14px;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: ${({ theme }) => theme.bg};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.text_secondary}55;
    color: ${({ theme }) => theme.text_primary};
    cursor: pointer;
    transition: color 0.15s ease, transform 0.15s ease;

    &:hover {
        color: ${({ theme }) => theme.primary};
        transform: scale(1.1);
    }
`;


const index = ({ openModal, setOpenModal }) => {
    const project = openModal?.project;
    return (
        <Modal open={true} onClose={() => setOpenModal({ state: false, project: null })}>
            <Container>
                <Wrapper>
                    <CloseButton onClick={() => setOpenModal({ state: false, project: null })} aria-label="Close">
                        <CloseRounded style={{ fontSize: 18 }} />
                    </CloseButton>
                    <RoughBox roughness={2.4} strokeWidth={2} padding="24px" seed={(project?.id ?? 0) * 29 + 13}>
                        {project?.image && <Image src={project.image} />}
                        <Title>{project?.title}</Title>
                        <Date>{project.date}</Date>
                        <Tags>
                            {project?.tags.map((tag, index) => (
                                <Tag key={index}>#{tag.replace(/\s+/g, '')}</Tag>
                            ))}
                        </Tags>
                        <Desc>
                            {Array.isArray(project?.description) ? (
                                project.description.map((bullet, index) => (
                                    <div key={index} style={{ marginBottom: '6px' }}>✎ {bullet}</div>
                                ))
                            ) : (
                                project?.description
                            )}
                        </Desc>
                        {project.member && (
                            <>
                                <Label>Members</Label>
                                <Members>
                                    {project?.member.map((member, index) => (
                                        <Member key={index}>
                                            <RoughCircle size={44} strokeWidth={1.3} roughness={2.3}>
                                                <MemberImage src={member.img} />
                                            </RoughCircle>
                                            <MemberName>{member.name}</MemberName>
                                            <a href={member.github} target="new" style={{textDecoration: 'none', color: 'inherit'}}>
                                                <GitHub />
                                            </a>
                                            <a href={member.linkedin} target="new" style={{textDecoration: 'none', color: 'inherit'}}>
                                                <LinkedIn />
                                            </a>
                                        </Member>
                                    ))}
                                </Members>
                            </>
                        )}
                        <ButtonGroup>
                            <RoughBox roughness={2.2} strokeWidth={1.6} padding="12px 16px" style={{ flex: 1 }}>
                                <Button dull href={project?.github} target='new'>View Code</Button>
                            </RoughBox>
                            <RoughBox roughness={2.2} strokeWidth={1.6} padding="12px 16px" style={{ flex: 1 }}>
                                <Button href={project?.webapp} target='new'>View Live App</Button>
                            </RoughBox>
                        </ButtonGroup>
                    </RoughBox>
                </Wrapper>
            </Container>

        </Modal>
    )
}

export default index